(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function setThemeAtcLabel(root, label) {
    const submit = root.querySelector('.product-form__submit > span');
    if (!submit || !label) return;
    const textNode = Array.from(submit.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (textNode) {
      if (textNode.textContent.trim() === label) return;
      textNode.textContent = label;
      return;
    }
    submit.insertBefore(document.createTextNode(label), submit.firstChild);
  }

  function watchThemeAtcLabel(root, label) {
    const submit = root.querySelector('.product-form__submit > span');
    if (!submit || submit.dataset.nestiOfferLabelWatch === 'true') return;
    submit.dataset.nestiOfferLabelWatch = 'true';
    const observer = new MutationObserver(() => setThemeAtcLabel(root, label));
    observer.observe(submit, { childList: true, characterData: true, subtree: true });
  }

  function shouldShowStickyBar(entry) {
    if (!entry || entry.isIntersecting) return false;
    return entry.boundingClientRect.top < 0;
  }

  function syncBarVisibility(bar, show) {
    bar.hidden = !show;
    document.documentElement.classList.toggle('nesti-offer-close-bar-visible', show);
  }

  function syncBarFromAtcButton(atcButton, bar) {
    if (!atcButton || !bar) return;
    const show = mobileQuery.matches && atcButton.getBoundingClientRect().top < 0;
    syncBarVisibility(bar, show);
  }

  function bindOfferClose(root) {
    if (!root || root.dataset.nestiOfferCloseBound === 'true') return;
    if (!root.hasAttribute('data-nesti-offer-close')) return;

    const sectionEl = root.closest('.shopify-section') || root;
    const atcButton = root.querySelector('.product-form__submit[name="add"]');
    const bar = sectionEl.querySelector('[data-nesti-offer-bar]');
    if (!atcButton || !bar) return;

    root.dataset.nestiOfferCloseBound = 'true';
    syncBarFromAtcButton(atcButton, bar);

    const mainAtcLabel = root.getAttribute('data-nesti-main-atc-label') || 'Add To Cart';
    setThemeAtcLabel(root, mainAtcLabel);
    watchThemeAtcLabel(root, mainAtcLabel);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = mobileQuery.matches && shouldShowStickyBar(entry);
          syncBarVisibility(bar, show);
        });
      },
      { threshold: 0 }
    );
    observer.observe(atcButton);

    const onBreakpoint = () => syncBarFromAtcButton(atcButton, bar);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onBreakpoint);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onBreakpoint);
    }
  }

  function scrollToBuybox(event) {
    const trigger = event.target.closest('[data-nesti-jump-buybox]');
    if (!trigger) return;
    const target = document.querySelector('[data-nesti-offer-close]');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function bindSizeguideModal(dialog, root) {
    if (dialog.dataset.nestiSizeguideBound === 'true') {
      return;
    }

    const trigger = root.querySelector(`[aria-controls="${dialog.id}"]`);
    if (!trigger) {
      return;
    }

    dialog.dataset.nestiSizeguideBound = 'true';

    const closeButton = dialog.querySelector('[data-nesti-sizeguide-close]');

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        dialog.close();
      });
    }

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function initSizeguideModals(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nesti-sizeguide-modal]').forEach((dialog) => {
      bindSizeguideModal(dialog, scope === document ? document : scope);
    });
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-nesti-offer-close]').forEach(bindOfferClose);
    if (root.hasAttribute && root.hasAttribute('data-nesti-offer-close')) {
      bindOfferClose(root);
    }
    initSizeguideModals(root);
  }

  if (!window.__nestiOfferJumpBound) {
    window.__nestiOfferJumpBound = true;
    document.addEventListener('click', scrollToBuybox, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
